import { Box } from 'dash-ui';

function FAQsWidget() {
  return <Box></Box>;
}

export default FAQsWidget;
